import { Outlet } from "react-router-dom";
import Footer from "../common/Footer/Footer";
import AuthHeader from "../common/AuthHeader/AuthHeader";

const CMSLayout = (props) => {   
    return (
        <>
           <AuthHeader />
           <Outlet />
           <Footer />
        </>
    );   
}
export default CMSLayout;